// Login form.
import React from 'react';
import { FormattedMessage } from 'react-intl';

import CheckBox from '../widgets/checkbox.jsx';
import VisiblePassword from '../widgets/visible-password.jsx';

export default class LoginView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      login: props.login,
      password: '',
      hostName: props.serverAddress,
      saveToken: props.persist
    };
    this.handleLoginChange = this.handleLoginChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleToggleSaveToken = this.handleToggleSaveToken.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleLoginChange(e) {
    this.setState({login: e.target.value});
  }

  handlePasswordChange(e) {
    this.setState({password: e.target.value});
  }

  handleToggleSaveToken() {
    this.props.onPersistenceChange(!this.state.saveToken);
    this.setState({saveToken: !this.state.saveToken});
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onLogin(this.state.login.trim(), this.state.password.trim());
  }

  render() {
    let submitClasses = 'primary';
    if (this.props.disabled) {
      submitClasses += ' disabled';
    }

    // Katysha legal links footer — added 2026-05-12 for Wave A.4.
    // Plain <a> with absolute paths; opens in new tab so login flow is not
    // disrupted. No FormattedMessage to keep the change i18n-free.
    const katyshaLegalLinkStyle = {
      color: '#6b6b6b',
      textDecoration: 'none',
      marginRight: '10px'
    };
    const katyshaLegalFooterStyle = {
      marginTop: '16px',
      paddingTop: '12px',
      borderTop: '1px solid #e4e6ea',
      textAlign: 'center',
      fontSize: '0.78rem',
      color: '#6b6b6b',
      lineHeight: '1.6'
    };

    return (
      <React.Fragment>
        <form id="login-form" onSubmit={this.handleSubmit}>
          <FormattedMessage id="login_prompt" defaultMessage="Login"
            description="Placeholer for username/login">
          {
            (login_prompt) => <input type="text" id="inputLogin"
              placeholder={login_prompt}
              autoComplete="username"
              autoCorrect="off"
              autoCapitalize="none"
              value={this.state.login}
              onChange={this.handleLoginChange}
              required autoFocus />
          }
          </FormattedMessage>
          <FormattedMessage id="password_prompt" defaultMessage="Password"
            description="Placeholder/prompt for entering password">
          {
            (password_prompt) => <VisiblePassword type="password" id="inputPassword"
              placeholder={password_prompt}
              autoComplete="current-password"
              value={this.state.password}
              onChange={this.handlePasswordChange}
              required={true} />
          }
          </FormattedMessage>
          <div className="panel-form-row">
            <CheckBox id="save-token" name="save-token" checked={this.state.saveToken}
              onChange={this.handleToggleSaveToken} />
            <label htmlFor="save-token">&nbsp;
              <FormattedMessage id="stay_logged_in" defaultMessage="Stay logged in"
                description="Label for a checkbox" />
            </label>
            <a href="#reset">
              <FormattedMessage id="forgot_password_link" defaultMessage="Forgot password?"
                description="Link to Reset password form" />
            </a>
          </div>
          {/* EMAIL-RESET (MVP-RELEASE-001 S5): reset by email works only if the profile has one; otherwise support resets it. */}
          <div className="panel-form-row">
            <span className="small gray">
              <FormattedMessage id="forgot_password_hint" defaultMessage="No email in your profile? Write to {support}"
                description="Hint under the forgot-password link"
                values={{support: <a href="mailto:support@katysha.app">support@katysha.app</a>}} />
            </span>
          </div>
          <div className="dialog-buttons">
            <button className={submitClasses} type="submit">
              <FormattedMessage id="button_sign_in" defaultMessage="Sign in"
                description="Button [Sign In]" />
            </button>
          </div>
        </form>
        <div className="katysha-legal-links" style={katyshaLegalFooterStyle}>
          <a href="/privacy/" target="_blank" rel="noopener noreferrer" style={katyshaLegalLinkStyle}>Privacy</a>
          <a href="/terms/" target="_blank" rel="noopener noreferrer" style={katyshaLegalLinkStyle}>Terms</a>
          <a href="/support/" target="_blank" rel="noopener noreferrer" style={katyshaLegalLinkStyle}>Support</a>
          <a href="/account-deletion/" target="_blank" rel="noopener noreferrer" style={katyshaLegalLinkStyle}>Delete&nbsp;account</a>
          <a href="/community-guidelines/" target="_blank" rel="noopener noreferrer" style={{color: '#6b6b6b', textDecoration: 'none'}}>Community</a>
        </div>
      </React.Fragment>
    );
  }
};
